import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const IconListItem = ({ icon , label , url  })=>{
    const WrapperElement = url ? Link : 'div';
    return /*#__PURE__*/ React.createElement("li", {
        className: "icon-list-item"
    }, /*#__PURE__*/ React.createElement(WrapperElement, {
        className: "icon-list-item__inner",
        url: url
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    }), label && /*#__PURE__*/ React.createElement("span", {
        className: "icon-list-item__text"
    }, label)));
};
var IconListItem$1 = IconListItem;

export { IconListItem$1 as default };
//# sourceMappingURL=IconListItem.js.map
